interface ICustomError {
  message: string | undefined;
  resource: string;
  errorCode?: string | undefined;
}
class CustomError extends Error {
  resource: string;
  errorCode?: string | undefined;
  constructor({ message, resource, errorCode }: ICustomError) {
    super(message);
    this.name = 'ConfigException';
    this.resource = resource;
    this.errorCode = errorCode;
  }
}

export default CustomError;
